import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './components/PublicNavbarStyles.css';

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppDefaults } from 'config/global-enums';
import { Image, Typography } from 'antd';
import { Link } from 'react-router-dom';
import {
  ChannelsSubMenuRoutes,
  useCasesSubMenuRoutes,
} from 'modules/Home/routes';

const { Text, Title } = Typography;

const productsMenuItems = [
  // {
  //   key: '/products/carma',
  //   title: '<strong>CARMA</strong> - AI for Sales & Marketing',
  //   descption:
  //     'Customer Acquisition, Retention, and Marketing through AI Platform',
  //   imgSrc: '/images/NavImages/acquisition.png',
  // },
  {
    key: '/products/magics',
    title: '<strong>MAGICS</strong> - AI for Customer Support',
    descption:
      'Multilingual AI-Generated Interactive Customer Service Platform',
    imgSrc: '/images/NavImages/customer-service.png',
  },
  {
    key: '/products/craft',
    title: '<strong>CRAFT</strong> - AI for Channel Partner Sales & Support',
    descption:
      'Channel Partner Resources and Assistance Framework with AI Technology Platform',
    imgSrc: '/images/NavImages/channel-partner.png',
  },
  {
    key: '/products/selfi',
    title: '<strong>SELFI</strong> - AI For Employee-HR Support',
    descption: 'Self-Service Employee Learning and Facilitation Interface',
    imgSrc: '/images/NavImages/employees.png',
  },
  // {
  //   key: '/products/star',
  //   title: 'Service & Technical Assistance Resource Platform (STAR)',
  //   descption: 'An AI platform that streamlines the tasks of team members.',
  //   imgSrc: '/images/NavImages/service-technical.png',
  // },
  // {
  //   key: '/products/capture',
  //   title:
  //     'Customer Analytics & Predictive Tools for Understanding Retention and Engagement (CAPTURE) Platform',
  //   descption: 'An AI platform to to reduce churn with data-driven insights.',
  //   imgSrc: '/images/NavImages/customer-analytics.png',
  // },
];

const solutionsMenuItems = [
  {
    key: '/solutions/isp',
    title: 'Internet Service Provider (ISP)',
    imgSrc: '/images/NavImages/worldwide.png',
  },
  {
    key: '/solutions/ecommerce',
    title: 'E-commerce',
    imgSrc: '/images/NavImages/online-shopping.png',
  },
  {
    key: '/solutions/websites',
    title: 'Business Websites',
    imgSrc: '/images/NavImages/internet.png',
  },
  {
    key: '/solutions/wordpress',
    title: 'Wordpress',
    imgSrc: '/images/NavImages/wordpress.png',
  },
];

const channelsMenuItems = [
  {
    key: ChannelsSubMenuRoutes.WEB_WIDGET,
    title: 'Web Widget',
    imgSrc: '/images/NavImages/WW-chat.png',
  },
  {
    key: ChannelsSubMenuRoutes.WHATSAPP_BUSINESS_API,
    title: 'WhatsApp Business API',
    imgSrc: '/images/NavImages/WA-whatsapp.png',
  },
  {
    key: ChannelsSubMenuRoutes.FACEBOOK_MESSENGER,
    title: 'Facebook Messenger',
    imgSrc: '/images/NavImages/FB-messenger.png',
  },
  {
    key: ChannelsSubMenuRoutes.INSTAGRAM,
    title: 'Instagram',
    imgSrc: '/images/NavImages/IG-messenger.png',
  },
];

const useCasesMenuItems = [
  {
    key: useCasesSubMenuRoutes.SALES,
    title: 'Sales',
  },
  {
    key: useCasesSubMenuRoutes.MARKETING,
    title: 'Marketing',
  },
  {
    key: useCasesSubMenuRoutes.LEAD_GENERATION,
    title: 'Lead Generation',
  },
  {
    key: useCasesSubMenuRoutes.CUSTOMER_SUPPORT,
    title: 'Customer Support',
  },
  {
    key: useCasesSubMenuRoutes.EMPLOYEE_SUPPORT,
    title: 'Employee Support',
  },
  {
    key: '/solutions/ecommerce',
    title: 'Ecommerce',
  },
];

const CustomMenuItem = ({ item }) => {
  return (
    <Link to={item.key} className="list-group-item" key={item.key}>
      <div style={{ display: 'flex' }}>
        {item?.imgSrc && (
          <img
            src={item.imgSrc}
            alt="ai"
            style={{
              width: '24px',
              height: '24px',
              marginRight: '8px',
            }}
          />
        )}

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Text
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: '#000',
            }}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: item.title,
              }}
            ></span>
          </Text>
          <Text
            style={{
              fontSize: 12,
              color: '#000',
            }}
          >
            {/* {item.descption} */}
            <span
              dangerouslySetInnerHTML={{
                __html: item.descption,
              }}
            ></span>
          </Text>
        </div>
      </div>
    </Link>
  );
};

export default function NewPublicNavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const getNavColor = () => {
    switch (location.pathname.slice(1)) {
      case 'about-us':
        return '#ffffff';

      case 'products/craft':
        return '#ffffff';

      case 'products/carma':
        return '#ffffff';

      case 'products/magics':
        return '#ffffff';

      case 'products/selfi':
        return '#ffffff';

      case 'solutions/isp':
        return '#ffffff';

      case 'solutions/ecommerce':
        return '#ffffff';

      case 'solutions/websites':
        return '#ffffff';

      case 'solutions/wordpress':
        return '#ffffff';

      case 'solutions/channels/instagram':
        return '#FD96A0';

      case 'solutions/channels/whatsapp-business-api':
        return '#258638';

      case 'solutions/channels/facebook-messenger':
        return '#0866FF';

      case 'use-cases/sales':
        return '#ffffff';

      case 'use-cases/lead-generation':
        return '#ffffff';

      case 'use-cases/customer-support':
        return '#ffffff';

      case 'use-cases/employee-support':
        return '#ffffff';

      case 'use-cases/marketing':
        return '#ffffff';

      default:
        return '#ffffff';
    }
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg  navbar-light"
        style={{ backgroundColor: getNavColor() }}
      >
        <div className="container-fluid">
          <Link to="/" aria-label="Go to Home Page">
            <div className="navbar-brand">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Image
                  height={46}
                  preview={false}
                  style={{
                    float: 'left',
                    width: 'auto',
                    marginRight: '0.6rem',
                  }}
                  src={'/logo-emoji-black.svg?x=10000000'}
                  alt="Cleandesk AI logo"
                />
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // marginRight: !isMobile && '2rem',
                    minWidth: 'fit-content',
                  }}
                >
                  <Text
                    style={{
                      color: '#181818',
                      // color: customTheme.secondary,
                      fontWeight: 600,
                      fontSize: '1.4rem',
                      lineHeight: 1,
                    }}
                  >
                    {AppDefaults.APP_NAME}
                  </Text>
                  <Text
                    style={{
                      margin: '0 0px 0 6px',
                      fontSize: 10,
                      cursor: 'pointer',
                      textAlign: 'right',
                      color: '#181818',
                    }}
                  >
                    Beta
                  </Text>
                </span>
              </div>
            </div>
          </Link>

          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <span
                  className="nav-link"
                  aria-current="page"
                  onClick={() => navigate('/')}
                >
                  Home
                </span>
              </li>
              <li className="nav-item dropdown dropdown-mega position-static">
                <span
                  className="nav-link dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  Products
                </span>
                <div className="dropdown-menu shadow">
                  <div className="mega-content px-4">
                    <div className="container-fluid">
                      <div className="row">
                        {/* <div className="col-12 col-sm-4 col-md-3 py-4"> */}
                        <div className="col-12 col-sm-8 col-md-6 py-4">
                          <Title level={5}>Products</Title>
                          <div className="list-group">
                            {/* <a className="list-group-item" href="#">
                              Accomodations
                            </a>
                            <a className="list-group-item" href="#">
                              Terms & Conditions
                            </a>
                            <a className="list-group-item" href="#">
                              Privacy
                            </a> */}
                            {productsMenuItems.map((product, index) => (
                              <Link
                                to={product.key}
                                className="list-group-item"
                                key={index}
                              >
                                <div style={{ display: 'flex' }}>
                                  <img
                                    src={product.imgSrc}
                                    alt="ai"
                                    style={{
                                      width: '24px',
                                      height: '24px',
                                      marginRight: '8px',
                                    }}
                                  />
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'flex-start',
                                    }}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 600,
                                        color: '#000',
                                      }}
                                    >
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: product.title,
                                        }}
                                      ></span>
                                    </Text>
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        color: '#000',
                                      }}
                                    >
                                      {/* {product.descption} */}
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: product.descption,
                                        }}
                                      ></span>
                                    </Text>
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>
                        </div>
                        {/* <div className="col-12 col-sm-4 col-md-3 py-4">
                          <Title level={5}>Card</Title>
                          <div className="card">
                            <img
                              src="https://via.placeholder.com/320x180"
                              className="img-fluid"
                              alt="placw"
                            />
                            <div className="card-body">
                              <p className="card-text">
                                Some quick example text to build on the card
                                title and make up the bulk of the card's
                                content.
                              </p>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 col-sm-4 col-md-3 py-4">
                          <Title level={5}>Use Cases</Title>
                          {/* <p>
                            Lorem ipsum dolo sit achmet muhamed borlan de irtka.
                          </p> */}
                          <div className="list-group">
                            {useCasesMenuItems.map((product, index) => (
                              <CustomMenuItem key={index} item={product} />
                            ))}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4 col-md-3 py-4">
                          <Title level={5}>Channels</Title>
                          <div className="list-group">
                            {channelsMenuItems.map((product, index) => (
                              <CustomMenuItem key={index} item={product} />
                            ))}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4 col-md-3 py-4">
                          <Title level={5}>Solutions</Title>
                          {/* <p>
                            Lorem ipsum dolo sit achmet muhamed borlan de irtka.
                          </p> */}
                          <div className="list-group">
                            {solutionsMenuItems.map((product, index) => (
                              <CustomMenuItem key={index} item={product} />
                            ))}
                          </div>
                        </div>
                        {/* <div className="col-12 col-sm-12 col-md-3 py-4">
                          <Title level={5}>Damn, so many</Title>
                          <div className="list-group">
                            <a
                              className="list-group-item"
                              href="/use-cases/sales"
                            >
                              Accomodations
                            </a>
                            <a className="list-group-item" href="#">
                              Terms & Conditions
                            </a>
                            <a className="list-group-item" href="#">
                              Privacy
                            </a>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              {/* <li className="nav-item dropdown dropdown-mega half position-static"> */}
              {/* <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  Solutions
                </span>
                <div className="dropdown-menu custom-half-menu shadow">
                  <div className="mega-content px-4">
                    <div className="container-fluid">
                      <div className="row"> */}
              {/* <div className="col-12 col-sm-12 col-md-6 py-4"> */}
              {/* <div className="col-12 py-4">
                          <Title level={5}>Solutions</Title>
                          <div className="list-group">
                            {solutionsMenuItems.map(product => (
                              <CustomMenuItem item={product} />
                            ))}
                          </div>
                        </div> */}
              {/* <div className="col-12 col-sm-12 col-md-6 py-4">
                          <Title level={5}>Channels</Title>
                          <div className="list-group">
                            {channelsMenuItems.map(product => (
                              <CustomMenuItem item={product} />
                            ))}
                          </div>
                        </div> */}
              {/* </div>
                    </div>
                  </div>
                </div>
              </li> */}
              <li className="nav-item">
                <span
                  className="nav-link"
                  aria-current="page"
                  onClick={() => navigate('/features')}
                >
                  Features
                </span>
              </li>
              <li className="nav-item">
                <span
                  className="nav-link"
                  aria-current="page"
                  onClick={() => navigate('/pricing')}
                >
                  Pricing
                </span>
              </li>
              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Demo
                </span>
                <div
                  className="dropdown-menu shadow"
                  aria-labelledby="navbarDropdown"
                  style={{ padding: 0 }}
                >
                  <div className="list-group">
                    <a href="/demo/chat-site" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Webassist - Site
                      </Text>
                    </a>
                    <a href="/demo/chat-box" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Webassist - Box
                      </Text>
                    </a>
                    <a href="/demo/mobile-view" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Mobile View
                      </Text>
                    </a>
                    <a href="/demo/instagram" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Instagram
                      </Text>
                    </a>
                    <a href="/demo/whatsapp" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Whatsapp
                      </Text>
                    </a>
                    <a href="/demo/facebook" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Facebook
                      </Text>
                    </a>
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <span
                  className="nav-link"
                  aria-current="page"
                  onClick={() => navigate('/partners')}
                >
                  Partners
                </span>
              </li>

              {/* <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Resources
                </span>
                <div
                  className="dropdown-menu shadow"
                  aria-labelledby="navbarDropdown"
                  style={{ padding: 0 }}
                >
                  <div className="list-group">
                    <div className="list-group-item">
                      <a
                        href="https://docs.cleandesk.ai"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Text
                          style={{
                            fontSize: 14,
                            color: '#000',
                          }}
                        >
                          Developers
                        </Text>
                      </a>
                    </div>
                    <div className="list-group-item">
                      <a
                        href="https://blogs.cleandesk.ai"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Text
                          style={{
                            fontSize: 14,
                            color: '#000',
                          }}
                        >
                          Blogs
                        </Text>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Company
                </span>
                <div
                  className="dropdown-menu shadow"
                  aria-labelledby="navbarDropdown"
                  style={{ padding: 0 }}
                >
                  <div className="list-group">
                    <Link to="/about-us" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        About
                      </Text>
                    </Link>
                    <Link to="/contact-us" className="list-group-item">
                      <Text
                        style={{
                          fontSize: 14,
                          color: '#000',
                        }}
                      >
                        Contact Us
                      </Text>
                    </Link>
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <span
                  className="nav-link"
                  aria-current="page"
                  onClick={() => navigate('/integrated-apps')}
                >
                  Integrated Apps
                </span>
            </li> */}
            </ul>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <span className="btn" onClick={() => navigate('/signin')}>
                Sign in
              </span>
              <span
                className="btn secondary-btn"
                onClick={() => navigate('/signup')}
              >
                Sign up
              </span>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
